import Modal from "react-bootstrap/Modal";
import { CustomSelect } from "../../../shared/components/CustomSelect";
import styled from "styled-components";
import { useEffect, useState } from "react";
import {
    addProjectOtcPackage,
    getAllTokens,
    getApprovers,
} from "../../../utils/services/user.service";
import { Ring } from "@uiball/loaders";
import { toast } from "react-toastify";
import { Button } from "@/shared/components/Button";
import { FaFileAlt } from "react-icons/fa";

const CreateProjectOTCPackage = ({
    show,
    hide,
    reFetchPackages,
    marketplace_id,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [chain_id, setChain_id] = useState(null);
    const [packageChoice, setPackageChoice] = useState("active");
    const [pool1, setPool1] = useState("");
    const [pool2, setPool2] = useState("");
    const [allTokens, setAllTokens] = useState([]);
    const [selectedToken, setSelectedToken] = useState("");
    const [allTokensPool2, setAllTokensPool2] = useState([]);
    const [searchLoad, setsearchLoad] = useState(false);
    const [searchUserId, setSearchUserId] = useState([]);
    const [dropdownOptions, setDropdownOptions] = useState([]);
    const [selectedOTCType, setSelectedOTCType] = useState("trade"); // State for radio buttons
    const [documents, setDocuments] = useState([]);
    const [images, setImages] = useState([]);

    const handleRemoveFile = (type, index) => {
        if (type === "image") {
            setImages(images.filter((_, i) => i !== index));
        } else if (type === "document") {
            setDocuments(documents.filter((_, i) => i !== index));
        }
    };
    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        setImages([...images, ...files]);
    };

    const handleDocumentUpload = (e) => {
        const files = Array.from(e.target.files);
        setDocuments([...documents, ...files]);
    };

    // Add these remove handlers
    const removeDocument = (index) => {
        setDocuments(prev => prev.filter((_, i) => i !== index));
    };

    const removeImage = (index) => {
        setImages(prev => prev.filter((_, i) => i !== index));
    };

    useEffect(() => {
        // Filter and map the allTokens array
        const options = allTokens.map(token => ({
            value: token.symbol,
            label: token.symbol
        }));

        const handleOTCTypeChange = (e) => {
            setSelectedOTCType(e.target.value);
        };
        // Update the state with the new dropdown options
        setDropdownOptions(options);

        const Pool2Coins = allTokens
            // .filter(token => token.symbol !== 'BTC')  // Filter out the BTC token
            .map(token => ({
                value: token.symbol,
                label: token.symbol
            }));

        setAllTokensPool2(Pool2Coins);




    }, [allTokens]);
    const [packageInfo, setpackageInfo] = useState({
        packageName: "",
        packagePrice: "",
        buyAmount: null,
        token: null,
        transfer_fee: null,
        description: "",
        contract_address: "",
        unlockDay: null,


    });
    const { packageName, packagePrice, buyAmount, token, description, unlockDay } =
        packageInfo;
    const initialTokenData = dropdownOptions.map((item) => ({
        symbol: null,
        price: null,
    }));

    const [tokenData, setTokenData] = useState(initialTokenData);
    const newArray = tokenData.filter(
        (item) => item !== null && item !== undefined
    );
    const handleChange = (e) => {
        const { name, value } = e.target;
        setpackageInfo((prevInfo) => ({
            ...prevInfo,
            [name]: value,
        }));
    };

    const handleOTCTypeChange = (e) => {
        setSelectedOTCType(e.target.value);
    };

    const ctyArray=[
        {
            label:"CTYSHR",
            value:"CTYSHR"
        }
    ]
    const CreateNewOtcMarketplacePackage = async () => {
        try {
            if (!packageName || !description || !packagePrice) {
                toast.error("Please fill in all required fields");
                return;
            }
            if (selectedOTCType === "tracking" && (!packageName || !description || !packagePrice || images.length < 1 || documents.length < 1)) {
                toast.error("Please fill in all required fields");
                return;
            }

            setIsLoading(true);

            const poolVal = [pool1, pool2].join("-");
            const formData = new FormData();

            // Append text fields
            formData.append("market_place_id", marketplace_id);
            formData.append("price", packagePrice);
            formData.append("token", token);
            formData.append("package_name", packageName);
            formData.append("package_description", description);
            formData.append("pool", poolVal);
            formData.append("package_status", "active");
            formData.append("otc_type", selectedOTCType);

            // Append image files
            images.forEach((image, index) => {
                formData.append(`File`, image); // Single key for multiple images
            });

            // Append document files
            documents.forEach((doc, index) => {
                formData.append(`File2`, doc); // Single key for multiple documents
            });

            const res = await addProjectOtcPackage(formData);

            toast.success(res.data.Message);
            setIsLoading(false);
            reFetchPackages();
            hide();
        } catch (error) {
            toast.error(error?.response?.data?.Message || "Something went wrong");
            setIsLoading(false);
        }
    };



    const fetchAllTokens = async () => {
        const payload = {
            chain_id: "",
            limit: 100,
            page_number: 1
        };
        const res = await getAllTokens(payload);
        setAllTokens(res.data.user);
    };
    useEffect(() => {
        fetchAllTokens();
    }, []);
    return (
        <>
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={show}
                onHide={hide}
            >
                <div
                    className="loader-overlay"
                    style={{
                        display: isLoading ? "flex" : "none",
                        justifyContent: "center",
                        alignItems: "center",
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(255, 255, 255, 0.8)",
                        zIndex: 999,
                    }}
                >
                    <Ring size={65} color="#00897B" />
                </div>
                <Modal.Header closeButton>
                    <Modal.Title className="text-center" style={{ fontSize: "large" }}>
                        <b> Create Project OTC Package</b>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="d-flex flex-column" style={{ boxShadow: "none", fontFamily: "sans-serif" }}>
                        {/* Radio Buttons */}
                        {/* <div className="d-flex justify-content-start mb-4">
                            <div className="form-check me-4">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="otcType"
                                    id="otcWithTrades"
                                    value="trade"
                                    checked={selectedOTCType === "trade"}
                                    onChange={handleOTCTypeChange}
                                    required
                                />
                                <label className="form-check-label" htmlFor="otcWithTrades">
                                    OTC with Trades
                                </label>
                            </div>
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="radio"
                                    name="otcType"
                                    id="otcWithHistory"
                                    value="tracking"
                                    checked={selectedOTCType === "tracking"}
                                    onChange={handleOTCTypeChange}
                                    required
                                />
                                <label className="form-check-label" htmlFor="otcWithHistory">
                                    OTC with History and Tracking
                                </label>
                            </div>
                        </div> */}

                        <div className="d-flex flex-row flex-wrap gap-4">
                            <div className="col-12 col-md-4">
                                <label>Package Name</label>
                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="packageName"
                                        value={packageName}
                                        className="form-control mt-2"
                                        placeholder="Package Name"
                                        onChange={handleChange}
                                        required
                                    />
                                </InputDiv>
                            </div>

                            <div className="col-12 col-md-4">
                                <label className="d-flex gap-1">Price of package <span style={{ fontSize: '8px' }}>Token You Get</span></label>
                                <InputDiv>
                                    <ChatSearchInput
                                        type="number"
                                        name="packagePrice"
                                        value={packagePrice}
                                        className="form-control mt-2"
                                        placeholder="Package Price"
                                        onChange={handleChange}
                                        required
                                    />
                                </InputDiv>
                            </div>

                            <div className="flex flex-col col-12 col-md-3">
                                <label>Package Price Symbol</label>
                                <InputDiv>
                                    <DropdownDiv className="mb-0">
                                        <CustomSelect
                                            name="receiver"
                                            placeholder={`${pool1 ? pool1 : "Select Symbol"}`}
                                            onChange={(value) => setPool1(value.label)}
                                            value={pool1}
                                            options={allTokensPool2}
                                            isSearchable
                                            required
                                        />
                                    </DropdownDiv>
                                </InputDiv>
                            </div>

                            <div className="col-12 col-md-3">
                                <label className="d-flex gap-1">Token to Get <span style={{ fontSize: '8px' }}>Token You Pay</span></label>
                                <InputDiv>
                                    <ChatSearchInput
                                        type="number"
                                        name="token"
                                        value={token}
                                        className="form-control mt-2"
                                        placeholder="Token to sell"
                                        onChange={handleChange}
                                        required
                                    />
                                </InputDiv>
                            </div>

                            <div className="flex flex-col col-12 col-md-3">
                                <label>Token to Sell Symbol</label>
                                <InputDiv>
                                    <DropdownDiv className="mb-0">
                                        <CustomSelect
                                            name="receiver"
                                            placeholder={`${pool2 ? pool2 : "Select Symbol"}`}
                                            onChange={(value) => setPool2(value.label)}
                                            value={pool2}
                                            options={selectedOTCType === "tracking" ? ctyArray :dropdownOptions}
                                            isSearchable
                                            required
                                        />
                                    </DropdownDiv>
                                </InputDiv>
                            </div>

                            <div className="col-12 col-md-3">
                                <label>Description</label>
                                <InputDiv>
                                    <ChatSearchInput
                                        type="text"
                                        name="description"
                                        value={description}
                                        className="form-control mt-2"
                                        placeholder="Enter Description"
                                        onChange={handleChange}
                                        required
                                    />
                                </InputDiv>
                            </div>
                            {selectedOTCType === "tracking" &&
                                <><InputDiv>
                                    <label htmlFor="images" className="form-label text-black">Upload Images</label>
                                    <input type="file" multiple accept="image/*" onChange={handleImageUpload} className="form-control mt-2" required />
                                    <PreviewContainer>
                                        {images.map((file, index) => (
                                            <PreviewItem key={index}>
                                                <img src={URL.createObjectURL(file)} alt="preview" />
                                                <button onClick={() => handleRemoveFile("image", index)}>Remove</button>
                                            </PreviewItem>
                                        ))}
                                    </PreviewContainer>
                                </InputDiv><InputDiv>
                                        <label htmlFor="documents" className="form-label text-black">Upload Documents</label>
                                        <input type="file" multiple accept=".pdf,.doc,.docx" onChange={handleDocumentUpload} className="form-control mt-2" required />
                                        <PreviewContainer>
                                            {documents.map((file, index) => (
                                                <PreviewItem key={index}>
                                                    <div className="document-preview">
                                                        <FaFileAlt />
                                                        <p>{file.name}</p>
                                                    </div>
                                                    <button onClick={() => handleRemoveFile("document", index)}>Remove</button>
                                                </PreviewItem>
                                            ))}
                                        </PreviewContainer>
                                    </InputDiv></>}
                        </div>

                        <div className="d-flex justify-content-center">
                            <FormButton
                                type="submit"
                                variant="contain-success"
                                className="py-2 mt-2 col-12 col-md-4"
                                onClick={CreateNewOtcMarketplacePackage}
                            >
                                Create New Package
                            </FormButton>
                        </div>
                    </div>
                </Modal.Body>

            </Modal>
        </>
    );
};
export default CreateProjectOTCPackage;
const InputDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  padding: 5px 0px;
  font-size: 14px;
`;
const DropdownDiv = styled.div`
  display: block;
  @media screen and (max-width: 876px) {
    width: 100%;
  }
`;
const FormButton = styled(Button)`
  color: "white";
  mergin-top: 1rem;
`;
const ChatSearchInput = styled.input`
  width: 100%;
  height: 100%;
  font-size: 12px;
  transition: all 0.3s;
  background: transparent;
  border: none;
  padding-left: 2px;
  border-bottom: 1px solid #b1b1b1;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  color: black;

  &:focus,
  &:active {
    outline: none;
    box-shadow: none;
    // color: #b1b1b1;
    background: transparent;
    border-bottom: 2px solid #47c9a4;
  }

  &::-webkit-input-placeholder {
    color: #b1b1b1;
  }
  &::-moz-placeholder {
    color: #b1b1b1;
  }
  &:-moz-placeholder {
    color: #b1b1b1;
  }
  &:-ms-input-placeholder {
    color: #b1b1b1;
  }
`;
const SelectedFilesContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
`;

const SelectedFileItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 4px 8px;
  background: #f5f5f5;
  border-radius: 4px;
`;

const RemoveFileBtn = styled.button`
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
`;

const SelectedImagesContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 8px;
`;

const SelectedImageItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80px;
`;

const ImagePreviewContainer = styled.div`
  position: relative;
  width: 60px;
  height: 60px;
`;

const ImagePreview = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 4px;
`;

const RemoveImageBtn = styled.button`
  position: absolute;
  top: -8px;
  right: -8px;
  background: #ff4444;
  color: white;
  border: none;
  border-radius: 50%;
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 12px;
  padding: 0;
`;

const ImageName = styled.span`
  font-size: 10px;
  text-align: center;
  word-break: break-all;
  margin-top: 4px;
`; const PreviewContainer = styled.div`
display: flex;
flex-wrap: wrap;
gap: 10px;
margin-top: 10px;
`;

const PreviewItem = styled.div`
display: flex;
flex-direction: column;
align-items: center;
gap: 5px;

img {
  width: 80px;
  height: 80px;
  object-fit: cover;
  border-radius: 5px;
}

p {
  font-size: 12px;
  text-align: center;
}

button {
  font-size: 10px;
  color: red;
  border: none;
  background: none;
  cursor: pointer;
}
`;